mapboxgl.accessToken =
  "pk.eyJ1IjoiYWxlam9mYW50YXN0aWNmeSIsImEiOiJjbGV5ZGE3dmUwM3h1M3JzMjVmdGhxNXR5In0.C6wRcI-E_pbhOK2hi7i_jA";

const formatStoreData = ({
  id,
  name,
  address: {
    address1,
    address2,
    city,
    country,
    latitude,
    longitude,
    phone,
    zip,
    province,
  },
}) => ({
  type: "Feature",
  geometry: {
    type: "Point",
    coordinates: [longitude, latitude],
  },
  properties: {
    id: id,
    name: name,
    phoneFormatted: phone,
    phone: phone,
    address: address1,
    city: city,
    country: country,
    crossStreet: address2,
    postalCode: zip,
    state: province,
  },
});

const getStoreLocations = async () => {
  const res = await fetch("/apps/location-control/store-locator", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const { data } = await res.json();
  const stores = data.filter((loc) => !loc.shipsInventory).map(formatStoreData);
  const {
    address: { latitude, longitude },
  } = data.find((loc) => loc.shipsInventory);
  const center = [longitude, latitude];

  return { stores, center };
};

(async () => {

  const zoom = document.querySelector('#map').dataset.zoom.split(',');

  /**
   * Add a listing for each store to the sidebar.
   **/
  const buildLocationList = (stores) => {
    for (const store of stores.features) {
      /* Add a new listing section to the sidebar. */
      console.log(store)
      const listings = document.getElementById("listings");

      const listing = listings.appendChild(document.createElement("div"));

      /* Assign a unique `id` to the listing. */
      listing.id = `listing-${store.properties.id}`;

      /* Assign the `item` class to each listing for styling. */
      listing.className = "item";

      /* Add the link to the individual listing created above. */
      const link = listing.appendChild(document.createElement("a"));
      link.href = "#";
      link.className = "title";
      link.id = `link-${store.properties.id}`;
      link.innerHTML = `${store.properties.name}`;

      /**
       * Listen to the element and when it is clicked, do four things:
       * 1. Update the `currentFeature` to the store associated with the clicked link
       * 2. Fly to the point
       * 3. Close all other popups and display popup for clicked store
       * 4. Highlight listing in sidebar (and remove highlight for all other listings)
       **/
      link.addEventListener("click", function () {
        for (const feature of stores.features) {
          if (this.id === `link-${feature.properties.id}`) {
            flyToStore(feature);
            createPopUp(feature);
          }
        }
        const activeItem = document.getElementsByClassName("active");
        if (activeItem[0]) {
          activeItem[0].classList.remove("active");
        }
        this.parentNode.classList.add("active");
      });
    }
  };

  const { stores: locations, center } = await getStoreLocations();

  const stores = {
    type: "FeatureCollection",
    features: locations,
  };

  const checkZoom = () => {
    return window.innerWidth <= 550  ?  Number(zoom[1]) : Number(zoom[0])
  }

  const map = new mapboxgl.Map({
    container: "map",
    style: "mapbox://styles/mapbox/light-v11",
    center: center,
    zoom: checkZoom(),
  });

  

  /**
   * Wait until the map loads to make changes to the map.
   */
  map.on("load", () => {
    /**
     * This is where your '.addLayer()' used to be, instead
     * add only the source without styling a layer
     */
    map.addSource("places", {
      type: "geojson",
      data: stores,
    });

    /**
     * Add all the things to the page:
     * - The location listings on the side of the page
     * - The markers onto the map
     */
    buildLocationList(stores);
    addMarkers();
  });

  /**
   * Add a marker to the map for every store listing.
   **/
  const addMarkers = () => {
    /* For each feature in the GeoJSON object above: */
    for (const marker of stores.features) {
      /* Create a div element for the marker. */
      const el = document.createElement("div");

      /* Assign a unique `id` to the marker. */
      el.id = `marker-${marker.properties.id}`;

      /* Assign the `marker` class to each marker for styling. */
      el.className = "marker";

      /**
       * Create a marker using the div element
       * defined above and add it to the map.
       **/
      new mapboxgl.Marker(el, {
        offset: [0, -23],
      })
        .setLngLat(marker.geometry.coordinates)
        .addTo(map);

      /**
       * Listen to the element and when it is clicked, do three things:
       * 1. Fly to the point
       * 2. Close all other popups and display popup for clicked store
       * 3. Highlight listing in sidebar (and remove highlight for all other listings)
       **/
      el.addEventListener("click", (e) => {
        /* Fly to the point */
        flyToStore(marker);

        /* Close all other popups and display popup for clicked store */
        createPopUp(marker);

        /* Highlight listing in sidebar */
        const activeItem = document.getElementsByClassName("active");
        e.stopPropagation();
        if (activeItem[0]) {
          activeItem[0].classList.remove("active");
        }
        const listing = document.getElementById(
          `listing-${marker.properties.id}`
        );
        listing.classList.add("active");
      });
    }
  };

  /**
   * Create a Mapbox GL JS `Popup`.
   **/
const createPopUp = (currentFeature) => {
  const popUps = document.getElementsByClassName("mapboxgl-popup");
  if (popUps[0]) popUps[0].remove();

  new mapboxgl.Popup({ focusAfterOpen: false })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(`<h3>${currentFeature.properties.name}</h3>`)
    .addTo(map);
};


  /**
   * Use Mapbox GL JS's `flyTo` to move the camera smoothly
   * a given center point.
   **/
  const flyToStore = (currentFeature) => {
    map.flyTo({ center: currentFeature.geometry.coordinates, zoom: 15 });
  };
})();
